import { OngoingSection, Question } from "../types/assessmentOngoing";

export const sequentializeList = (
  data: OngoingSection[] | Question[],
  type: "sections" | "questions"
) => {
  if (!data || data.length === 0) return [];

  if (type === "sections") {
    return new Array(...data).sort(
      (a, b) =>
        (a as OngoingSection).orderInQp - (b as OngoingSection).orderInQp
    );
  }

  if (type === "questions") {
    return new Array(...data).sort(
      (a, b) => (a as Question).orderInSection - (b as Question).orderInSection
    );
  }

  return [];
};
